import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { RxTemplate } from '@shared/rx-templates/rx-template.model';
import { ProcedureMap } from '@shared/models/procedure-map';
import { ISectionDirtyCheckService } from '@shared/models/section-dirty-check';
import { OrderQuery } from '@modules/order/state/order-query';
import { SurgicalGuideVisibilityService } from './surgical-guide-visibility.service';

@Injectable({ providedIn: 'root' })
export class SurgicalGuideDirtyCheckService implements ISectionDirtyCheckService {
	constructor(
		private readonly orderQuery: OrderQuery,
		private readonly visibilityService: SurgicalGuideVisibilityService
	) {}

	willLoseDataFor$(targetTemplate: Readonly<RxTemplate>, targetProcedureMap: ProcedureMap | null): Observable<boolean> {
		return this.visibilityService.fieldsFor$(targetTemplate, targetProcedureMap).pipe(
			withLatestFrom(this.visibilityService.fields$, this.visibilityService.isSectionVisible$),
			map(([tgt, cur, isVisible]) => isVisible && cur.procedureType && !tgt.procedureType && this.orderQuery.hasProcedureTypeId)
		);
	}
}
